import { useTranslation } from 'react-i18next';

import { NCCard, NCCard2SectionLayout, NCCardComplianceFooter, NCCardHeader } from '@/components/NCCard/NCCard';
import { BiodiversityExplainer } from '@/components/NCExplainers/BiodiversityExplainer';
import { BetaPill } from '@/components/Pill/BetaPill';
import { COMPLIANCE_LOGOS_BIODIVERSITY } from '@/config/constants';

import { BiodiversityCardGraphTile } from './GraphTile';
import { BiodiversityCardStatsTile } from './StatsTile';

export const BiodiversityCard = () => {
  const { t } = useTranslation();

  return (
    <NCCard explainer={<BiodiversityExplainer />}>
      <NCCardHeader
        title={
          <span className='flex flex-row items-center gap-3'>
            {t('shared.ncaDetail.details.biodiversity.labels.protectedOnFarmHabitat')}
            <BetaPill />
          </span>
        }
      />
      <NCCard2SectionLayout>
        <BiodiversityCardGraphTile />
        <BiodiversityCardStatsTile />
      </NCCard2SectionLayout>
      <NCCardComplianceFooter logos={COMPLIANCE_LOGOS_BIODIVERSITY} />
    </NCCard>
  );
};
